import React from 'react';
import { RenderNode } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';

import { BlockContainer, Layout, Column } from '../../Layout';
import { Text } from '../../Text';
import RichText from '../../RichText';

import { Table, Row, HeaderCell, Cell, Paragraph } from './styles';

import { TableProps } from '../shared';

export function StandardTable({ title, tableBody, tableId }: TableProps) {
  const RICH_TEXT_OVERRIDES: RenderNode = {
    [BLOCKS.TABLE]: (_node, children) => (
      <Table>
        <tbody>{children}</tbody>
      </Table>
    ),
    [BLOCKS.TABLE_ROW]: (_node, children) => <Row>{children}</Row>,
    [BLOCKS.TABLE_HEADER_CELL]: (_node, children) => (
      <HeaderCell data-testid="st-header-cell">{children}</HeaderCell>
    ),
    [BLOCKS.TABLE_CELL]: (_node, children) => <Cell>{children}</Cell>,
    [BLOCKS.PARAGRAPH]: (_node, children) => <Paragraph>{children}</Paragraph>
  };

  return (
    <BlockContainer
      id={tableId!}
      marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      data-testid="standard-table"
    >
      <Layout>
        <Column size={{ 0: 12, tablet: 8 }} flexDirection="column">
          {title && (
            <Text
              textAlign="center"
              style={{ marginBottom: '2rem', fontWeight: 'bold' }}
            >
              {title}
            </Text>
          )}
          <RichText data={tableBody} overrideOptions={RICH_TEXT_OVERRIDES} />
        </Column>
      </Layout>
    </BlockContainer>
  );
}
